// $5
export const MINIMUM_PROGRESS_VALUE = 4;
